<template lang="pug">
  .my-shops-container
    v-card.rounded-lg(height="95%")
      v-card-title.justify-center.main-title-primary Mis tiendas
      v-row.mx-auto.justify-center.shops-row-card
        v-col.py-0.my-0.circular-center-column.justify-start(cols="4" md="4" lg="4" xl="3")
          v-card.circular-card.d-flex.align-center.justify-center(style="background: #0f6d93 !important;" to="/dashboard/create-shop")
            v-img(src="@/assets/icons/delivery/shop.png" contain height="50")
          p.rounded-card__title.font-weight-bold(style="color: #0f959b !important") Crear tienda
        v-col.py-0.my-0.circular-center-column.justify-start( cols="4" md="4" lg="4" xl="3" v-for="shop of shops")
          v-card.elevation-8.circular-card(:to="'/dashboard/shops/'+shop.id")
            v-img(v-if="shop.pictures.imageInput1" :src="shop.pictures.imageInput1" cover style="height: 100%; border-radius: 50px")
            v-img(v-else :src="shopPlaceHolder" cover style="height: 100%; border-radius: 50px")
          p {{shop.name}}
</template>

<script>
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  export default {
    name: 'ShopHome',
    components: {
      createShop: () => import('@/views/custom/CreateShop'),
    },
    data: () => ({
      shopPlaceHolder,
      createShopDialog: false,
    }),
    computed: {
      shops () {
        return this.$store.getters['shops/getItems']
      },
    },
  }
</script>

<style lang="scss">
  .my-shops-container{
    height: 95%;
    .shops-row-card{
      height: 350px;
      overflow-x: hidden;
      overflow-y: scroll;
      scrollbar-width: none;
    }
    .shops-row-card{
      scrollbar-width: none;
    }
    .shops-row-card::-webkit-scrollbar {
      display: none;
    }
  }
</style>
